import styled from "@emotion/styled";
import * as React from "react";
import TextareaAutosize from "react-textarea-autosize";

import { ITextAreaFieldProps } from "@livechat/design-system";
import { DesignToken, FormField, RadiusToken, SpacingToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

// @ts-expect-error TS2322
const TextAreaAutosizeField: React.FC<
  ITextAreaFieldProps & { ref?: React.Ref<HTMLTextAreaElement>; className?: string }
> = React.forwardRef<HTMLTextAreaElement, ITextAreaFieldProps>((props, ref) => {
  const {
    inline,
    error,
    description,
    labelText,
    id,
    onFocus,
    onBlur,
    onChange,
    value,
    disabled,
    placeholder,
    className,
  } = props;

  return (
    <TextareaFormField
      inline={inline}
      error={error}
      description={description}
      labelText={labelText}
      className={className}
    >
      <Textarea
        cacheMeasurements
        id={id}
        ref={ref}
        onFocus={onFocus}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        placeholder={placeholder}
        disabled={!!disabled}
        error={!!error}
      />
    </TextareaFormField>
  );
});

TextAreaAutosizeField.displayName = "TextAreaAutosizeField";

const Textarea = styled(TextareaAutosize)<{ error: boolean; disabled: boolean }>`
  color: var(${DesignToken.ContentBasicPrimary});
  background-color: var(${DesignToken.SurfacePrimaryDefault});
  border-color: var(
    ${({ error }): string => (error ? DesignToken.BorderBasicNegative : DesignToken.BorderBasicPrimary)}
  );
  border-radius: var(${RadiusToken.Radius3});
  padding: var(${SpacingToken.Spacing2}) var(${SpacingToken.Spacing3});
  box-sizing: border-box;
  width: 100%;
  resize: none;
  min-height: 56px;
  font-size: 14px;

  ::placeholder {
    color: ${({ disabled }): string =>
      withVar(disabled ? DesignToken.ContentBasicDisabled : DesignToken.ContentBasicPlaceholder)};
    opacity: ${({ disabled }): number => (disabled ? 0.2 : 0.4)};
  }

  &:disabled {
    cursor: not-allowed;
  }

  &:focus,
  &:active {
    border-color: var(
      ${({ error }): string => (error ? DesignToken.BorderBasicNegative : DesignToken.ActionPrimaryDefault)}
    );
    outline: none;
  }
`;

const TextareaFormField = styled(FormField)`
  width: 100%;
  margin: 0;
`;

export default TextAreaAutosizeField;
